(() => {

    class FullBleedSlider {

        constructor(root) {

            this.root = root;

            this.track = root.querySelector('[data-track]');

            if (!this.track)
                return;

            this.prev = root.querySelector('[data-prev]');
            this.next = root.querySelector('[data-next]');

            this.originalSlides = [...this.track.children];

            this.count = this.originalSlides.length;

            if (this.count < 2)
                return;

            this.duration = 450;

            this.autoplayDelay = 4500;

            this.timer = null;

            this.lock = false;

            this.dragging = false;

            this.startX = 0;
            this.currentX = 0;
            this.startTranslate = 0;

            this.slideWidth = 0;

            this.index = 0;

            this.build();

        }

        build() {

            const fragment = document.createDocumentFragment();

            for (let i = 0; i < 5; i++) {

                this.originalSlides.forEach(slide => {

                    fragment.appendChild(
                        slide.cloneNode(true)
                    );

                });

            }

            this.track.innerHTML = '';

            this.track.appendChild(fragment);

            this.slides = [...this.track.children];

            this.index = this.count * 2;

            this.measure();

            this.goTo(this.index, false);

            this.bind();

            this.startAutoplay();

        }

        measure() {

            if (!this.slides.length)
                return;

            const style =
                getComputedStyle(this.track);

            const gap =
                parseFloat(
                    style.columnGap ||
                    style.gap ||
                    0
                );

            this.slideWidth =
                this.slides[0].getBoundingClientRect().width +
                gap;

        }

        bind() {

            window.addEventListener('resize', () => {

                this.measure();

                this.goTo(
                    this.index,
                    false
                );

            });

            this.next?.addEventListener(
                'click',
                () => this.nextSlide()
            );

            this.prev?.addEventListener(
                'click',
                () => this.prevSlide()
            );

            this.track.addEventListener(
                'transitionend',
                () => {

                    if (this.index >= this.count * 3) {

                        this.index -= this.count;

                        this.goTo(this.index, false);

                    }

                    else if (this.index < this.count * 2) {

                        this.index += this.count;

                        this.goTo(this.index, false);

                    }

                }
            );

            this.root.addEventListener(
                'mouseenter',
                () => {

                    this.stopAutoplay();

                }
            );

            this.root.addEventListener(
                'mouseleave',
                () => {

                    this.startAutoplay();

                }
            );

            document.addEventListener(
                'visibilitychange',
                () => {

                    if (
                        document.hidden
                    ) {

                        this.stopAutoplay();

                    }

                    else {

                        this.startAutoplay();

                    }

                }
            );

            this.enableDrag();

        }

        translate(
            x,
            animate = true
        ) {

            this.track.style.transition =
                animate
                    ? `transform ${this.duration}ms cubic-bezier(.22,.61,.36,1)`
                    : 'none';

            this.track.style.transform =
                `translate3d(${x}px,0,0)`;

        }

        goTo(
            index,
            animate = true
        ) {

            this.index = index;

            this.translate(
                -(this.slideWidth * index),
                animate
            );

        }

        nextSlide() {

            if (this.lock)
                return;

            this.unlockLater();

            this.goTo(
                this.index + 1
            );

        }

        prevSlide() {

            if (this.lock)
                return;

            this.unlockLater();

            this.goTo(
                this.index - 1
            );

        }

        startAutoplay() {

            this.stopAutoplay();

            this.timer = setInterval(
                () => {

                    this.goTo(
                        this.index + 1
                    );

                },
                this.autoplayDelay
            );

        }

        stopAutoplay() {

            clearInterval(
                this.timer
            );

        }

        unlockLater() {

            this.lock = true;

            setTimeout(() => {

                this.lock = false;

            }, 1000);

        }

        enableDrag() {

            const down = x => {

                this.dragging = true;

                this.stopAutoplay();

                this.startX = x;

                this.currentX = x;

                this.startTranslate =
                    -(this.index * this.slideWidth);

                this.track.style.transition = 'none';

            };

            const move = x => {

                if (!this.dragging)
                    return;

                this.currentX = x;

                const delta =
                    this.currentX - this.startX;

                this.translate(
                    this.startTranslate + delta,
                    false
                );

            };

            const up = () => {

                if (!this.dragging)
                    return;

                this.dragging = false;

                const delta =
                    this.currentX - this.startX;

                if (delta < -60) {

                    this.nextSlide();

                }

                else if (delta > 60) {

                    this.prevSlide();

                }

                else {

                    this.goTo(
                        this.index
                    );

                }

                this.startAutoplay();

            };

            this.track.addEventListener(
                'mousedown',
                e => {

                    e.preventDefault();

                    down(
                        e.clientX
                    );

                }
            );

            window.addEventListener(
                'mousemove',
                e => {

                    move(
                        e.clientX
                    );

                }
            );

            window.addEventListener(
                'mouseup',
                up
            );

            this.track.addEventListener(
                'touchstart',
                e => {

                    down(
                        e.touches[0].clientX
                    );

                },
                {
                    passive:true
                }
            );

            this.track.addEventListener(
                'touchmove',
                e => {

                    move(
                        e.touches[0].clientX
                    );

                },
                {
                    passive:true
                }
            );

            this.track.addEventListener(
                'touchend',
                up
            );

            this.track.addEventListener(
                'dragstart',
                e => e.preventDefault()
            );

        }

    }

    document
        .querySelectorAll(
            '[data-full-bleed-slider]'
        )
        .forEach(root => {

            new FullBleedSlider(
                root
            );

        });

})();